// Non-breaking space character
// Used to replace regular spaces to preserve line height of lines with only spaces
export const NON_BREAKING_SPACE = '\u00A0';

// Line break characters
export const LINE_BREAK = {
  // Carriage return (Mac/Windows line break)
  CR: '\r',
  // Line feed (Unix/Windows line break)
  LF: '\n',
  // Windows line break
  CRLF: '\r\n',
} as const;

export const REGULAR_SPACE = ' ';

// Variation Selector-16 (VS-16) - used for emoji presentation
export const VARIATION_SELECTOR_16 = '\uFE0F';
